import * as React from 'react'
import { PriceWithSpinner } from '@components/loaders/price-with-spinner'

interface Props {
  text: string
  price: string | number
  isCalculating?: boolean
  children?: React.ReactNode
}

export const SectionSummaryPriceRow = ({ price, text, isCalculating, children }: Props): JSX.Element => (
  <div className="bg-light-blue border-top">
    <div className="p-3 px-xl-5 container-lg">
      <div className="d-flex justify-content-between text-primary align-items-center" data-testid="price-summary">
        <strong className="d-block font-size-lg">{text}</strong>
        <PriceWithSpinner priceItemClassName="d-block font-size-xxl" price={price} isLoading={!!isCalculating} />
      </div>
      {children}
    </div>
  </div>
)
